import { faUserShield } from "@fortawesome/pro-regular-svg-icons/faUserShield";
import { Formik } from "formik";
import PropTypes from "prop-types";
import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import Card from "reactstrap/es/Card";
import CardBody from "reactstrap/es/CardBody";
import Col from "reactstrap/es/Col";
import Row from "reactstrap/es/Row";

// App
import {
  ButtonCancel,
  ButtonSave,
  ContentBody,
  ContentErrors,
  ContentHeader,
  ContentHeaderButtons,
  ContentHeaderTitle,
  Error403,
} from "../../core/components";
import { FormikForm } from "../../core/components/formik";
import { ROUTE_ROLE } from "../../../constants";

// Auth
import { authRefresh } from "../../auth/actions/auth";
import { usePermission } from "../../auth/hooks/usePermission";

// Role
import { formClear, formFetch, formInit, formSubmitUpdate } from "../actions/role";
import { RoleFieldsetBase, RoleFieldsetPermissions } from "../components";

const RolePageEdit = (props) => {
  const { formData, formDataPermissions, formErrors, formIsSubmitting, history, identity, match } = props;
  const [hasPermission] = usePermission();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("title.roles");

    props.formFetch(match.params.id).then(() => {
      props.formInit(formData, match.params.id);
    });

    return () => {
      props.formClear();
    };
  }, []);

  const handleSubmit = (values) => {
    props.formSubmitUpdate(values, match.params.id).then(() => {
      if (identity.idRoles.includes(parseInt(match.params.id))) {
        props.authRefresh();
      }
      if (0 === props.formErrors.length) {
        history.push(ROUTE_ROLE);
      }
    });
  };

  // Kontrola opravneni
  if (!hasPermission("role.update")) {
    return <Error403 />;
  }

  return (
    <Fragment>
      <ContentHeader>
        <ContentHeaderTitle icon={faUserShield} title={t("title.roles")} />
        <ContentHeaderButtons>
          <ButtonSave
            disabled={formIsSubmitting}
            executing={formIsSubmitting}
            form="form-roles"
            text={t("action.save")}
          />
          <ButtonCancel text={t("action.cancel")} to={ROUTE_ROLE} />
        </ContentHeaderButtons>
      </ContentHeader>

      <ContentErrors errors={formErrors} />

      <ContentBody>
        <Formik
          enableReinitialize={true}
          initialValues={{
            name: formData.name || "",
            idPermissions: formData.idPermissions || [],
          }}
          onSubmit={handleSubmit}
          render={(formik) => (
            <FormikForm id="form-roles" onSubmit={formik.handleSubmit}>
              <Row>
                <Col>
                  <Card>
                    <CardBody>
                      <RoleFieldsetBase />
                    </CardBody>
                  </Card>
                </Col>
                <Col>
                  <Card>
                    <CardBody>
                      <RoleFieldsetPermissions permissions={formDataPermissions} />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </FormikForm>
          )}
        />
      </ContentBody>
    </Fragment>
  );
};

RolePageEdit.propTypes = {
  authRefresh: PropTypes.func.isRequired,
  formClear: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  formDataPermissions: PropTypes.array.isRequired,
  formErrors: PropTypes.array.isRequired,
  formFetch: PropTypes.func.isRequired,
  formInit: PropTypes.func.isRequired,
  formIsSubmitting: PropTypes.bool.isRequired,
  formSubmitUpdate: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  authRefresh,
  formClear,
  formFetch,
  formInit,
  formSubmitUpdate,
};

const mapStateToProps = (state) => ({
  formData: state.role.formData,
  formDataPermissions: state.role.formDataPermissions,
  formErrors: state.role.formErrors,
  formIsSubmitting: state.role.formIsSubmitting,
});

export default connect(mapStateToProps, mapDispatchToProps)(RolePageEdit);
